import { Button } from "@mui/material";
import { appColors } from "../../constants/theme";
import { pageActionButtonSx } from "../../constants/pageActionBar";

/**
 * PageActionBar içinde kullanılan ortak aksiyon butonu.
 * variant: outlined (filtre vb.) | contained (birincil aksiyon)
 */
const PageActionButton = ({
  variant = "outlined",
  color = "primary",
  sx = {},
  ...props
}) => {
  const variantSx =
    variant === "contained"
      ? color === "inherit"
        ? { px: 2.25 }
        : {
            px: 2.25,
            backgroundColor: appColors.primary,
            "&:hover": {
              backgroundColor: appColors.primaryDark,
            },
          }
      : {
          borderColor: appColors.gray200,
          color: appColors.gray900,
          "&:hover": {
            borderColor: appColors.gray500,
            backgroundColor: appColors.gray50,
          },
        };

  return (
    <Button
      variant={variant}
      color={color}
      size="small"
      sx={[pageActionButtonSx, variantSx, sx]}
      {...props}
    />
  );
};

export default PageActionButton;
